export const users = [
  {
    id: 1,
    name: "DKP",
    profileUrl:
      "https://avatars0.githubusercontent.com/u/39042169?s=400&u=c8ba8d2fb5e70175917bf939978014ea41ed5ba7&v=4",
    description:
      "React, Vue, Node, Mongo, PostgreSQL | ElasticSearch | NLP, Amazon intern ,Web developer",
  },
  {
    id: 2,
    name: "Elon Musk",
    profileUrl:
      "https://www.biography.com/.image/t_share/MTY2MzU3Nzk2OTM2MjMwNTkx/elon_musk_royal_society.jpg",
    description: "Something in your dreams, Tesla ,SpaceX , PayPal",
  },
  {
    id: 3,
    name: "Jeff Bezoz",
    profileUrl:
      "https://thumbor.forbes.com/thumbor/fit-in/416x416/filters%3Aformat%28jpg%29/https%3A%2F%2Fspecials-images.forbesimg.com%2Fimageserve%2F5bb22ae84bbe6f67d2e82e05%2F0x0.jpg%3Fbackground%3D000000%26cropX1%3D560%26cropX2%3D1783%26cropY1%3D231%26cropY2%3D1455",
    description: "Amazon Owner",
  },
];
